import request from "../utils/fetch";
//列表
export function List(data) {
  return request({
    url: "/user/afterSales/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

//新增
export function add(data) {
  return request({
    url: "/user/afterSales/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

//编辑
export function edit(data) {
  return request({
    url: "/user/afterSales/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

//删除
export function del(data) {
  return request({
    url: "/user/afterSales/del",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//维护记录列表
export function maintainList(data) {
  return request({
    url: "/equipment/maintain/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
